import React from 'react';
import { styled } from '@mui/material';
import { Spinner } from './Spinner';

interface LoadingOverlayProps {
    isLoading: boolean;
    children: React.ReactNode;
}


const RootContainer = styled('div')({
    position: 'relative',
});

const ContentContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isLoading',
})<{ isLoading: boolean }>(({ isLoading }) => ({
    transition: 'opacity 300ms',
    opacity: isLoading ? 0.5 : 1,
    pointerEvents: isLoading ? 'none' : 'auto',
}));

const SpinnerContainer = styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: '8px',
});

export const LoadingOverlay = ({ isLoading, children }: LoadingOverlayProps) => {
    return (
        <RootContainer>
            <ContentContainer isLoading={isLoading}>
                {children}
            </ContentContainer>

            {isLoading && (
                <SpinnerContainer>
                    <Spinner />
                </SpinnerContainer>
            )}
        </RootContainer>
    );
};